import StringMask from 'string-mask';

export const formatMask = (
  str: string,
  mask: string,
  reverse?: boolean,
): string => {
  const formatter = new StringMask(mask, reverse && { reverse });
  const maskedString = formatter.apply(str);
  return maskedString;
};

export const smilesMaskEmail = (email: string): string | undefined => {
  try {
    const [before, after] = email.split('@');
    let unmaskedEndChar = 3;
    if (before.length == 3) {
      unmaskedEndChar = 2;
    } else if (before.length < 3) {
      unmaskedEndChar = 1;
    }
    const beforeLength = before.length;
    const maskedCharsLength = 7;
    const unmaskedChars = before.substr(beforeLength - unmaskedEndChar);
    const maskedEmail =
      '*'.repeat(maskedCharsLength) + unmaskedChars + '@' + after;
    return maskedEmail;
  } catch (error) {
    return;
  }
};

export const smilesMaskPhone = (
  DDI: string,
  DDD: string,
  phone: string,
): string | undefined => {
  try {
    if (phone.length <= 4) {
      return `${DDI} (${DDD}) ${'*'.repeat(phone.length)}`;
    } else {
      return `${DDI} (${DDD}) ${'*'.repeat(phone.length - 4)}-${phone.substr(
        phone.length - 4,
        4,
      )}`;
    }
  } catch (error) {
    return;
  }
};
